import { gql } from '@common/hooks';
import { ApprovalChainContentFragments } from '@approvals/graphql/fragments';
import { HistoryInfoFragment } from '@common/graphql';
import {
  EXTENSION_OFFER_DETAILS_FRAGMENT,
  EXTENSION_OFFER_HEADER_FRAGMENT,
} from './extension-offer-fragment';

export const CANDIDATE_ASSIGNMENT_COMPLEMENT_FRAGMENT = gql`
  fragment CandidateAssignmentComplementFragment on StaffingRequestAssignment {
    id
    startDate
    shiftsPerWeek
    hoursPerShift
    employmentType
    billingRegularRate

    extensionOffers {
      id
      state
      createdBy {
        id
        name
      }
      canRetract {
        value
      }
      canReject {
        value
      }
      canAccept {
        value
      }
      canApprove {
        value
      }
      ...ExtensionOfferApprovalChainsFragment
      ...ExtensionOfferHeaderFragment
      ...ExtensionOfferDetailsFragment
    }

    organization {
      id
      name
    }

    activeExtensionOffer {
      id
      history {
        ...HistoryInfoFragment
      }
      ...ExtensionOfferHeaderFragment
      ...ExtensionOfferDetailsFragment
    }

    staffingRequest {
      id
      code
      staffingRequestType

      role {
        id
        abbreviation
      }

      organizationUnit {
        id
        department {
          id
          name

          organizationBusiness {
            id
            name
            city
            stateCode
          }
        }
      }
    }
  }
  ${EXTENSION_OFFER_HEADER_FRAGMENT}
  ${EXTENSION_OFFER_DETAILS_FRAGMENT}
  ${ApprovalChainContentFragments.extensionOffer}
  ${HistoryInfoFragment}
`;
